import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const themes = {
    bordered: {
        background: COLORS.BgMain,
        borderWidth: '1px',
        radius: '4px',
        padding: '20px',
        mobilePadding: '15px',
        color: COLORS.TextPrimary,
    },
    simple: {
        background: 'transparent',
        borderWidth: '1px 0',
        radius: '0px',
        padding: '20px 0',
        mobilePadding: '15px 0',
        color: COLORS.TextPrimary,
    },
    light: {
        border: COLORS.BgLight,
        background: COLORS.BgLight,
        color: COLORS.TextPrimary,
        colorArrow: COLORS.GRAY_DARK,
        backgroundIcon: COLORS.BgSecondary,
        borderIcon: COLORS.BgSecondary,
        colorArrowIsOpen: COLORS.GRAY_DARK,
        backgroundIconIsOpen: COLORS.Outline_Light,
        borderIconIsOpen: COLORS.Outline_Light,
        radius: BorderRadius.componentRadius,
        padding: '20px 24px',
        mobilePadding: '15px',
        storyColor: COLORS.BgMain,
    },
    dark: {
        border: COLORS.Control,
        background: COLORS.Control,
        color: COLORS.TextWhite,
        colorArrow: COLORS.Control,
        backgroundIcon: COLORS.GRAY_DARK,
        borderIcon: COLORS.GRAY_DARK,
        colorArrowIsOpen: COLORS.Control,
        backgroundIconIsOpen: COLORS.TextWhite,
        borderIconIsOpen: COLORS.TextWhite,
        radius: BorderRadius.componentRadius,
        padding: '20px 24px',
        mobilePadding: '15px',
        storyColor: '#3D3D3D',
    },
};

export default themes;
